import { render } from "./ThePavilion.vue?vue&type=template&id=58b97396"
import script from "./ThePavilion.vue?vue&type=script&lang=js"
export * from "./ThePavilion.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__